import styled from 'styled-components'
import sortBy from 'lodash/sortBy'
import groupBy from 'lodash/groupBy'
import { H, P, Wrapper } from '@farewill/ui'
import { COLOR } from '@farewill/ui/tokens'
import { DOCUMENT_CATEGORIES } from 'utils/enums'
import type { DocumentWithAttributes } from 'lib/models/document'
import { SavedDocumentsExpandableCategory } from './saved-documents-expandable-category'

const BackgroundWrapper = styled(Wrapper)`
  position: relative;
`
const ROOT_PAGE_PADDING = 72
const FullWidthBackground = styled(Wrapper)`
  position: absolute;
  width: 200vw;
  height: calc(100% + ${ROOT_PAGE_PADDING}px);
  top: 0;
  left: -50vw;
  bottom: -${ROOT_PAGE_PADDING}px;
  z-index: -1;
  background-color: ${COLOR.BACKGROUND.FOG};
`

export const SavedDocuments = ({
  savedDocuments,
}: {
  savedDocuments: DocumentWithAttributes[]
}) => {
  const groupedDocuments = groupBy(savedDocuments, 'attributes.category')

  return (
    <BackgroundWrapper padding={['XL', 0]} background={COLOR.BACKGROUND.FOG}>
      <FullWidthBackground />
      <H tag="h2" size="M" margin={[0, 0, 'L']} color={COLOR.BLACK}>
        Saved documents
      </H>
      {savedDocuments.length === 0 ? (
        <P>No saved documents</P>
      ) : (
        <Wrapper tag="ul">
          {DOCUMENT_CATEGORIES.map((category) => {
            if (!groupedDocuments[category.value]) return null

            return (
              <SavedDocumentsExpandableCategory
                key={category.value}
                category={category}
                documents={sortBy(
                  groupedDocuments[category.value],
                  (doc) => -doc.id
                )}
              />
            )
          })}
        </Wrapper>
      )}
    </BackgroundWrapper>
  )
}
